<template>
    <div class="list-container">
        <h2>Assigned Students for {{ groupName }}</h2>
        <button class="btn btn-sm back-btn" @click="$router.push('/dashboard/groups')">⬅ Back to Groups</button>

        <div v-if="loading" class="loading-overlay">
            <div class="spinner"></div>
        </div>

        <ul v-else class="data-list">
            <li v-for="student in students" :key="student.id" class="list-item">
                <div class="item-info">
                    <span class="info-item"><strong>Name:</strong> {{ student.user.name }}</span>
                    <span class="info-item"><strong>Email:</strong> {{ student.user.email }}</span>
                </div>
                <button class="btn btn-sm btn-danger remove-btn" @click="removeStudent(student.student_id)">❌
                    Remove</button>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    data() {
        return {
            students: [],
            groupName: '',
            loading: false,
            groupId: this.$route.params.id
        };
    },
    methods: {
        async fetchAssignedStudents() {
            this.loading = true;
            try {
                const response = await this.$api.get(`/groups/${this.groupId}/students`);
                this.students = response.data;
            } catch (error) {
                console.error("Error fetching assigned students:", error);
            }
            this.loading = false;
        },
        async fetchGroupName() {
            try {
                const response = await this.$api.get(`/groups/${this.groupId}`);
                this.groupName = response.data.name;
            } catch (error) {
                console.error("Error fetching group name:", error);
            }
        },
        async removeStudent(studentId) {
            if (!confirm("Are you sure you want to remove this student from the group?")) return;
            try {
                await this.$api.delete(`/groups/${this.groupId}/remove-student/${studentId}`);
                this.students = this.students.filter(student => student.student_id !== studentId);
            } catch (error) {
                console.error("Error removing student:", error);
            }
        }
    },
    mounted() {
        this.fetchGroupName();
        this.fetchAssignedStudents();
    }
};
</script>

<style scoped>
.list-container {
    padding: 20px;
    background: white;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.data-list {
    list-style: none;
    padding: 0;
}

.list-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    background: #f8f9fa;
    border-radius: 5px;
    margin-bottom: 10px;
}

.info-item {
    display: block;
    margin-bottom: 5px;
}

.remove-btn {
    background-color: red;
    color: white;
    border: none;
    padding: 5px 10px;
    cursor: pointer;
    border-radius: 5px;
}

.remove-btn:hover {
    background-color: darkred;
}
</style>
